module.exports = __webpack_public_path__ + "static/media/desired.b030fd42.svg";